import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Fab, Typography, Box, Stack, Container, Skeleton } from '@mui/material';
import { openSharedDoor, getSharedBookInfo } from './api';
import { useHookState } from './NotificationApiHook';
import { useTheme } from '@mui/material/styles';
import PersonIcon from '@mui/icons-material/Person';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import NavigationOutlinedIcon from '@mui/icons-material/NavigationOutlined';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';

const SharedDoor = () => {
  const { pwd } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sharedBookData, setSharedBookData] = useState(null);
  const { notificationState } = useHookState();

  const theme = useTheme();
  const TimeSplitter = (time) => {
    const arr = time.replace(/"/g, '').split('+')[0].split(':');
    console.log(arr);
    const concatedTime = `${arr[0]}:${arr[1]}`;
    return concatedTime;
  };

  const handleOpenDoor = async () => {
    console.log(pwd);
    setLoading(true);
    try {
      await openSharedDoor(notificationState, pwd, sharedBookData.id);
      console.log('Дверь открыта успешно!');
    } catch (error) {
      console.error('Ошибка при открытии двери:', error);
      setError('Ошибка при открытии двери');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSharedBookInfo(pwd, notificationState).then((data) => {
      setSharedBookData(data);
    });
  }, []);

  if (!sharedBookData) {
    return (
      <Container sx={{ marginTop: '100px' }}>
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
      </Container>
    );
  }

  return (
    <div>
      <Box
        sx={{
          maxHeight: 'calc(100svh - 250px)',
          minHeight: 'calc(100svh - 250px)',
        }}
      >
        <Stack
          mt={3}
          direction='column'
        >
          <Typography
            mb={4}
            sx={{ fontSize: '1.2rem', width: '100%', fontWeight: 600, textAlign: 'center' }}
          >
            {`Вход в зал`}
          </Typography>
          <Stack
            direction='row'
            alignItems='center'
            gap={1}
            mb={4}
          >
            <PersonIcon />
            <Typography sx={{ fontSize: '1.1rem', width: '100%' }}>
              {`${sharedBookData.username} поделился с вами бронью`}
            </Typography>
          </Stack>

          <Stack
            direction='row'
            alignItems='center'
            gap={1}
            mb={4}
          >
            <CalendarMonthIcon />
            <Typography sx={{ fontSize: '1.1rem', width: '100%' }}>
              {`${new Date(sharedBookData.day).toLocaleDateString('ru-RU', {
                month: 'long',
                day: 'numeric',
              })}`}
              {', '}
              {`${new Date(sharedBookData.day).toLocaleDateString('ru-RU', {
                weekday: 'long',
              })}
                  `}
            </Typography>
          </Stack>
          <Stack
            direction='row'
            alignItems='center'
            gap={1}
            mb={4}
          >
            <QueryBuilderIcon />
            <Typography sx={{ fontSize: '1.1rem', width: '100%' }}>
              {`${TimeSplitter(sharedBookData.start_time)}`}
            </Typography>
          </Stack>
          <Stack
            direction='row'
            alignItems='center'
            gap={1}
            mb={4}
          >
            <NavigationOutlinedIcon />
            <Typography sx={{ fontSize: '1.1rem', width: '100%' }}>
              {`${sharedBookData.address}`}
            </Typography>
          </Stack>
          <Stack
            direction='row'
            alignItems='center'
            gap={1}
            mb={4}
          >
            <PhoneIphoneOutlinedIcon />
            <Typography
              sx={{ fontSize: '1.1rem', width: '100%' }}
            >{`${sharedBookData.phone}`}</Typography>
          </Stack>
          <Stack
            direction='row'
            alignItems='center'
            gap={1}
            mb={4}
          >
            <PriorityHighIcon />
            <Typography sx={{ fontSize: '0.9rem', width: '100%' }}>
              15 минут <b>до</b> и <b>после</b> интервала так же доступны для управления дверью
            </Typography>
          </Stack>
        </Stack>
      </Box>
      <Fab
        color='primary'
        onClick={() => {
          setLoading(true);
          handleOpenDoor();
        }}
        disabled={loading}
        sx={{
          backgroundColor: theme.palette.primary.main,
          position: 'sticky',
          bottom: '58px',
          display: 'block',
          width: '100%',
          maxWidth: '600px',
          height: '80px',
          lineHeight: '30px',
          padding: '15px',
          zIndex: '98',
          borderRadius: '0',

          '&.Mui-disabled': {
            backgroundColor: '#4b4b4b',
            color: theme.palette.primary.contrastText,
          },
        }}
      >
        {!loading ? `Открыть дверь` : `Дверь открывается...`}
      </Fab>
    </div>
  );
};

export default SharedDoor;
